export class WorkspaceAllowedPrincipalInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "principal",
            "baseName": "principal",
            "type": "CloudPrincipalInput",
            "format": ""
        },
        {
            "name": "permissions",
            "baseName": "permissions",
            "type": "Array<WorkspaceStoragePermission>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WorkspaceAllowedPrincipalInput.attributeTypeMap;
    }
    constructor() {
    }
}
